/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Read_MoreInputs */

const en_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read More`)
};

const ar_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اقرأ المزيد`)
};

const bn_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আরও পড়ুন`)
};

const de_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr lesen`)
};

const es_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer más`)
};

const fr_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la suite`)
};

const pt_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia mais`)
};

const zh_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

const tr_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devamını Oku`)
};

const ru_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подробнее`)
};

const pl_about_read_more = /** @type {(inputs: About_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeczytaj więcej`)
};

/**
* | output |
* | --- |
* | "Read More" |
*
* @param {About_Read_MoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_read_more = /** @type {((inputs?: About_Read_MoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Read_MoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_read_more(inputs)
	if (locale === "bn") return bn_about_read_more(inputs)
	if (locale === "de") return de_about_read_more(inputs)
	if (locale === "es") return es_about_read_more(inputs)
	if (locale === "fr") return fr_about_read_more(inputs)
	if (locale === "pt") return pt_about_read_more(inputs)
	if (locale === "zh") return zh_about_read_more(inputs)
	if (locale === "tr") return tr_about_read_more(inputs)
	if (locale === "ru") return ru_about_read_more(inputs)
	if (locale === "pl") return pl_about_read_more(inputs)
	return en_about_read_more(inputs)
});